import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom'
import { Get_SubjectCategory } from '../../api/api'

export default function TopNav() {
  // const cats = Get_SubjectCategory(1);
  // const [category, setCategory] = useState([]);

  // useEffect(() => {
  //   cats.then((res) => {
  //     console.log(res.data)
  //     setCategory(res.data)
  //   })
  // }, []);


  return (

    <div className='topnav'>
      <NavLink to={`/type/all`}>همه</NavLink>
      <NavLink to={`/type/games`}>بازی</NavLink>
      <NavLink to={`/type/videos`}>ویدئو</NavLink>

      {/* {category.map((i) => (
        i.parentId == null ? (<NavLink key={i.id} to={`/type/${i.id}`}>{i.title}</NavLink>) : ''
      ))} */}

    </div>
  )
}
